// Copyright (c) 2017 TrainHeroic LLC
// Actions for App Authentication

const ACTIONS = {
    AUTH_FAIL: 'auth-fail',
    AUTH_SET_SESSION_TOKEN: 'auth-set-session-token',
    AUTH_SUCCESS: 'auth-success'
};

export default ACTIONS;



// WEBPACK FOOTER //
// ./src/state/reducer/auth/actions.js